import { css } from '@emotion/react';

const IconStyles = ({ theme }) => css`
  font-size: 24px;
`;

export default IconStyles;
